// extracted by mini-css-extract-plugin
export default {"portfolio-item-container":"Portfolio_portfolio-item-container__J0bNv","overlay-text":"Portfolio_overlay-text__Td9bv"};